/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module basic-styles/overline
 */

import { Plugin } from 'ckeditor5/src/core';
import OverlineEditing from './overline/overlineediting';
import OverlineUI from './overline/overlineui';

/**
 * The overline feature.
 *
 * For a detailed overview check the {@glink features/basic-styles Basic styles feature documentation}
 * and the {@glink api/basic-styles package page}.
 *
 * This is a "glue" plugin which loads the {@link module:basic-styles/overline/overlineediting~OverlineEditing} and
 * {@link module:basic-styles/overline/overlineui~OverlineUI} plugins.
 *
 * @extends module:core/plugin~Plugin
 */
export default class Overline extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get requires() {
		return [ OverlineEditing, OverlineUI ];
	}

	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'Overline';
	}
}
